import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

var currencySymbols = ['€ Euro', '$ Dollar', '¢ Cent', '₤ Lira', '£ Pound', '¥ Japanese yen', 'Ұ Chinese Renminbi yuan', '^ Generic currency', '฿ Thai baht', '₡ Colón', '₫ Vietnamese đồng', 'ƒ Aruban Florin', '₭ Lao kip', '₥ Mill', '₦ Nigerian naira', 'P Botswana pula', 'Q Guatemalan Quetzal', 'R South African rand', 'Sk Slovak koruna', '₨ Rupee', 'Rp rupiah in Indonesia', 'R$ Brazilian real', 'S/. Peruvian sol', '₮ Mongolian tögrög', '₩ Korean won', '₪ Israeli new sheqel', 'Lm Malta Lira', 'Br Belarusian Rouble', 'zł Polish Zloty'];
var digitsSeparators = ['(space)', '.', ',', '`', '|', '_'];
/**
 * @param {string} format
 * @returns {import("./types").ParseFormatResult}
 */

var parse = function parse(format) {
  var formatType = detectFormatType(format);

  switch (formatType) {
    case 'currency':
      return parseCurrencyFormat(format);
  }

  return null;
};

var parseCurrencyFormat = function parseCurrencyFormat(format) {
  var result = parseFormatString(format);
  result.type = 'currency';
  return result;
};

var parseFormatString = function parseFormatString(format) {
  var result = {}; // now we have the format without the prefix ('number:', 'currency:' ... etc)

  format = removeFormatPrefix(format);
  result.sign = extractFormatSign(format);
  result.format = extractFormatString(format);
  return _objectSpread({}, result, parseCurrencyDecimalsAndThousandsSeparators(result.format));
};

var removeFormatPrefix = function removeFormatPrefix(format) {
  return format.substring(format.indexOf(':') + 1);
};
/**
 * @param {string} format
 */


var extractFormatString = function extractFormatString(format) {
  var thSeparatorIdx = format.indexOf('th');
  if (thSeparatorIdx == -1) return format;
  return format.substring(0, thSeparatorIdx).trim();
};

var extractFormatSign = function extractFormatSign(format) {
  var signIdx = format.indexOf('sign:');
  if (signIdx == -1) return '-';
  return format.substring(signIdx + 5);
};
/**
 * @param {string} formatStr
 * @returns {import("./types").ParseFormatResult}
 */


var parseCurrencyDecimalsAndThousandsSeparators = function parseCurrencyDecimalsAndThousandsSeparators(formatStr) {
  var result = {}; // search for currency symbols

  currencySymbols.forEach(function (symbol) {
    var pos = formatStr.indexOf(getCurrencySymbol(symbol));

    if (pos == 0) {
      result.prefix = symbol.split(' ')[0];
      formatStr = formatStr.substring(1);
    } else if (!!formatStr && pos == formatStr.length - 1) {
      result.suffix = symbol.split(' ')[0];
      formatStr = formatStr.substring(0, formatStr.length - 1);
    }
  });
  var decimalPos = 0;
  var decimalN = 0;
  var leadz = 0; //identify decimal separator

  for (var i = formatStr.length - 1; i != -1; --i) {
    var selStr = formatStr[i].charCodeAt(0) == 160 ? '(space)' : formatStr[i];

    if (digitsSeparators.indexOf(selStr) != -1) {
      result.decimalsSeparator = selStr;
      decimalPos = i;
      break;
    } else {
      if (selStr == '0') ++decimalN;
    }
  }

  for (var j = decimalPos - 1; j != -1; --j) {
    var _selStr = formatStr[j].charCodeAt(0) == 160 ? '(space)' : formatStr[j];

    if (digitsSeparators.indexOf(_selStr) != -1) {
      result.thousandsSeparator = _selStr;
      break;
    }
  }

  for (var k = decimalPos - 1; k != -1; --k) {
    if (formatStr[k] == '0') ++leadz;
  }

  result.leadingZeros = leadz;
  result.decimalPlaces = decimalN;
  return result;
};

var getCurrencySymbol = function getCurrencySymbol(symbol) {
  var spaceIdx = symbol.indexOf(' ');
  if (spaceIdx == -1) return symbol;
  return symbol.substring(0, spaceIdx);
};
/**
 * @param {string} format
 * @returns {import("./types").FormatType}
 */


var detectFormatType = function detectFormatType(format) {
  if (!format) return 'general';
  if (format.startsWith('number:')) return 'number';
  if (format.startsWith('currency:')) return 'currency';
  if (format.startsWith('percentage:')) return 'percentage';
  if (format.startsWith('date:')) return 'date';
  if (format.startsWith('custom:')) return 'custom';
  return 'general';
};

export default {
  parse: parse
};